enum OwnersStatic {
  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @type public
   * @description get check if matches
   */
  CheckMatches = "/v2/owners/check-matches",
  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @type public
   * @description get check if matches
   */
  CreateOwner = "/v2/owners/check-matches",
  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @type public
   * @description get check if matches
   */
  OwnersList = "/v2/owners/"
}

const OwnersDynamic = {
  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description owner detail
   */
  OwnerDetail: (id: string | number) => `/v2/owners/${id}`,
  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description owner detail
   */
  OwnerUpdate: (id: string | number) => `/v2/owners/${id}?_method=PUT`
};

export const OwnersEndpoints = {
  ...OwnersDynamic,
  ...OwnersStatic
};

export type OwnersEndpoints = typeof OwnersEndpoints;
